import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useParams, useLocation } from "react-router-dom";
import moment from "moment";
import { message, FloatButton } from "antd";
import { Col, Container, Row } from "react-bootstrap";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { PiSelection } from "react-icons/pi";

import Header from "../../component/header";
import Footer from "../../component/footer/footer";
import SubHeader from "./subHeader";
import PageHeader from "./components/pageHeader";
import { API } from "../../Config/API";
import { POST } from "../../utils/apiCalls";

import CropBox from "./components/cropBox";
import SelectionBox from "./components/selectionBox";

import CropImage from "./helpers/cropImage";
import SharePopup from "./components/sharePopup";
import ZoomPopup from "./components/zoomPopup";

function DetailScreen() {
  const params = useParams();
  const location = useLocation();
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading2, setIsLoading2] = useState(true);

  const [activeIndex, setActiveIndex] = useState(0);
  const [activePage, setActivePage] = useState<any>(null);
  const [activePreview, setactivePreview] = useState(false);
  const [activeZoom, setActiveZoom] = useState<any>(false);
  const [cropActive, setCropActive] = useState(false);

  const [cropComplete, setCropComplete] = useState(false);
  const [cropValue, setCropValue] = useState({});

  const [activeShare, setActiveShare] = useState(false);
  const [cropFile, setCropFile] = useState(null);

  const [touchStartX, setTouchStartX] = useState<number | null>(null);
  const [touchEndX, setTouchEndX] = useState<number | null>(null);

  window.addEventListener("keydown", function (event) {
    if (event.ctrlKey && event.shiftKey && event.key === "I") {
      event.preventDefault();
      message.error("Developer Tools are disabled.");
    }
  });

  document.addEventListener("contextmenu", (event) => event.preventDefault());

  useEffect(() => {
    const edition = params?.edition;
    const date = params?.date;
    const page = params?.page;
    const id = params?.id;

    // Check if newspaper data was passed via navigation state
    const navigationState = location.state as { newspaperData?: any } | null;
    const passedData = navigationState?.newspaperData;

    setIsLoading(true);

    if (passedData && String(passedData.id) === String(id)) {
      // Use the passed data directly - no API call needed
      setData(passedData);
      ChangePage(passedData?.epapercollections[0]);
      setIsLoading(false);
    } else {
      // Fallback: fetch from API if no data passed or id mismatch
      loadData(edition, date, page, id);
    }

    window.scrollTo(0, 0);
  }, [params, location.state]);

  const loadData = async (edition: any, date: any, page: any, id: any) => {
    try {
      setIsLoading(true);
      let url = API.EPAPER;
      let obj = {
        type: "all",
        edition: edition,
        limit: 20,
        createdAt: moment(date).subtract(1, "day").format("YYYY-MM-DD"),
      };
      const response: any = await POST(url, obj);
      if (response?.length) {
        // Find the newspaper that matches the exact id from URL
        const matchingNewspaper = response.find(
          (item: any) => String(item.id) === String(id)
        );

        // Use the matching newspaper, or fall back to first result
        const selectedNewspaper = matchingNewspaper || response[0];
        setData(selectedNewspaper);
        ChangePage(selectedNewspaper?.epapercollections[0]);
      } else {
        setData([]);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const clickArrow = (type: any) => {
    try {
      setIsLoading(true);
      if (type === "add") {
        var totalPages = Number(data?.epapercollections?.length) - 1;
        var num = activeIndex + 1;
        if (num >= totalPages) {
          setActiveIndex(totalPages);
          // message.info("Maximum page limit reached.");
        } else {
          setActiveIndex(num);
        }
      } else {
        var num = activeIndex - 1;
        if (num < 0) {
          setActiveIndex(0);
          // message.info("Minimum page limit reached.");
        } else {
          setActiveIndex(num);
        }
      }
      setTimeout(() => {
        setIsLoading(false);
      }, 5);
    } catch (err) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (data?.epapercollections?.length) {
      setIsLoading(true);
      let item = data?.epapercollections[activeIndex];
      ChangePage(item);
    }
  }, [activeIndex]);

  const ChangePage = async (file: any) => {
    try {
      setActivePage(null);
      if (file?.imageUrl) {
        setActivePage(file);
      }
      setIsLoading(false);
    } catch (err) {
      console.log("err", err);
      setIsLoading(false);
    }
  };

  const onFinishCrop = async (value: any) => {
    try {
      setIsLoading2(true);
      setActiveShare(true);

      // Clean and validate the image URL
      let imageUrl = activePage?.imageUrl;

      if (!imageUrl) {
        throw new Error("No image URL provided");
      }

      // Fix common URL encoding issues
      imageUrl = imageUrl.replace(/%3A/g, ":"); // Decode URL-encoded colons

      // Check for invalid time formats and fix them
      // imageUrl = imageUrl.replace(
      //   /(\d{2}):(\d{2}):(\d{2,})/g,
      //   (match: any, hours: any, minutes: any, seconds: any) => {
      //     // If seconds > 59, fix it
      //     if (parseInt(seconds) > 59) {
      //       seconds = (parseInt(seconds) % 60).toString().padStart(2, "0");
      //     }
      //     return `${hours}:${minutes}:${seconds}`;
      //   }
      // );

      let cropedFile: any = await CropImage(
        value?.area,
        value?.ref,
        imageUrl // Use cleaned URL
      );

      console.log("cropFile:", cropedFile);
      setCropFile(cropedFile);
      setIsLoading2(false);
    } catch (err) {
      console.log("Crop failed:", err);
      setActiveShare(false);
      setIsLoading2(false);
      console.log("err", err);

      // Show user-friendly error message
      message.error("Failed to crop image. Please try again.");
    }
  };

  const isMobileOrTablet = () =>
    typeof window !== "undefined" && window.innerWidth <= 1024;

  const handleTouchStart = (e: React.TouchEvent) => {
    if (!isMobileOrTablet() || cropActive) return;
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!isMobileOrTablet() || cropActive) return;
    setTouchEndX(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!isMobileOrTablet() || cropActive || touchStartX === null || touchEndX === null)
      return;
    const distance = touchStartX - touchEndX;
    const minSwipeDistance = 50; // px

    if (distance > minSwipeDistance) {
      // Swiped left (next page)
      clickArrow("add");
    } else if (distance < -minSwipeDistance) {
      // Swiped right (previous page)
      clickArrow("remove");
    }
    setTouchStartX(null);
    setTouchEndX(null);
  };

  return (
    <div>
      <Header />
      <SubHeader edition={params?.edition} date={params?.date} />
      <div className="detailScreen">
        <div className="detailScreen-arrow-leftBox">
          <div
            className="detailScreen-arrow-left"
            onClick={() => clickArrow("remove")}
          >
            <IoIosArrowBack size={40} />
          </div>
        </div>
        <Container fluid={false}>
          <Row>
            <Col sm={2} xs={12}>
              {/* <GoogleAds /> */}
            </Col>
            <Col sm={8} xs={12}>
              {/* <BoxAdd /> */}
              {isLoading ? (
                <div className="detailScreen-loading">Loading . . . </div>
              ) : (
                <div>
                  <PageHeader
                    totalPage={data?.epapercollections}
                    activeIndex={activeIndex}
                    acitvePreview={activePreview}
                    cropActive={cropActive}
                    activeZoom={activeZoom}
                    changePreview={(value: any) => setactivePreview(value)}
                    changeIndex={(value: any) => setActiveIndex(value)}
                    clickArrow={(value: any) => clickArrow(value)}
                    setCropActive={() => {
                      setCropActive(!cropActive);
                      if (cropActive) {
                        // When deactivating crop mode, reset crop state
                        setCropComplete(false);
                        setCropValue({});
                      }
                    }}
                    setActiveZoom={() => setActiveZoom(!activeZoom)}
                  />
                  <div
                    className="detailScreen-box"
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                  >
                    {cropActive ? (
                      <CropBox
                        page={activePage}
                        onChange={(value: any) => {
                          setCropValue(value);
                          if (value && value.area && value.area.width > 0 && value.area.height > 0) {
                            setCropComplete(true);
                          } else {
                            setCropComplete(false);
                          }
                        }}
                      />
                    ) : (
                      <SelectionBox
                        page={activePage}
                        onChange={(value: any) => {
                          setCropValue(value);
                          if (value) onFinishCrop(value);
                        }}
                      />
                    )}
                  </div>
                  <div className="detailScreen-box3">
                    Page - {activeIndex + 1}
                  </div>
                  {/* <GoogleAds /> */}
                </div>
              )}
            </Col>
            <Col sm={2} xs={12}>
              {/* <GoogleAds /> */}
            </Col>
          </Row>
        </Container>
        <div className="detailScreen-arrow-rightBox">
          <div
            className="detailScreen-arrow-left"
            onClick={() => clickArrow("add")}
          >
            <IoIosArrowForward size={40} />
          </div>
        </div>
      </div>
      {cropComplete ? (
        <FloatButton
          style={{ width: 80, height: 60, marginBottom: 20 }}
          icon={
            <div style={{ marginRight: 5 }}>
              <PiSelection size={25} />
            </div>
          }
          description={"Create"}
          shape="square"
          onClick={() => onFinishCrop(cropValue)}
          type="primary"
        />
      ) : null}

      {activeZoom ? (
        <ZoomPopup
          show={activeZoom}
          onClose={() => setActiveZoom(false)}
          src={activePage?.imageUrl}
        />
      ) : null}

      {activeShare ? (
        <SharePopup
          loading={isLoading2}
          file={cropFile}
          edition={params?.edition}
          page={activeIndex}
          date={params?.date}
          visible={activeShare}
          onClose={() => setActiveShare(false)}
        />
      ) : null}
      <Footer />
    </div>
  );
}

export default DetailScreen;
